// @flow
import PreferencesWidget from '../PreferencesWidget/PreferencesWidget';
import type { DialogState } from '../PreferencesWidget/types';

import UserWidget from '../UserWidget/UserWidget';
import UserWidgetMobileWithDrawer from '../UserWidget/UserWidgetMobileWithDrawer';

import styles from './FunnelWidgets.scss';

type Props = {
  preferencesDialog: DialogState,
};

// Show in the funnel pages
export function FunnelWidgets({
  preferencesDialog,
}: Props): React.MixedElement {
  return (
    <div className={styles.root}>
      <PreferencesWidget dialog={preferencesDialog} />
      {/* Desktop  */}
      <div className={styles.userWidgetDesktop}>
        <UserWidget />
      </div>
      {/* Mobile (with drawer) */}
      <div className={styles.userWidgetMobile}>
        <UserWidgetMobileWithDrawer />
      </div>
    </div>
  );
}
